import { createApp } from 'vue/dist/vue.esm-bundler';

// import Header from './twig/components/header/Header.vue';
import Video from './twig/components/video/Video.vue';
import Accordion from './twig/components/accordion/Accordion.vue';
import Modal from './twig/components/modal/Modal.vue';
import ModalBtn from './twig/components/modal/ModalBtn.vue';

import './styles/styles.scss';

const app = createApp({
  components: {
    // Header,
    Video,
    Accordion,
    Modal,
    ModalBtn,
  },
});

app.mount('#app');
